import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/google-login.png'


const _withScopeId = n => (_pushScopeId("data-v-b542a9d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "ml-3.5",
    src: _imports_0,
    alt: "Google login"
  })
], -1))

import { AuthorizationApi } from "@/service/AuthorizationApi";
import type { GoogleLogin } from "vue3-google-login";
import { getCurrentInstance } from 'vue';


const __default__ = {
  name: "CustomGoogleLogin",
  mounted() {
    // Cargar el script del cliente de autenticación de Google
    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  },
};


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { emit } = getCurrentInstance() || {};

const callback = async (data: { credential: any; access_token: any }) => {
  const response = await AuthorizationApi.authenticateWithGoogleAccessToken(
    data.access_token
  );
  const isNew = response.data.new;

  emit && emit('success', isNew);
};

return (_ctx: any,_cache: any) => {
  const _component_GoogleLogin = _resolveComponent("GoogleLogin")!

  return (_openBlock(), _createBlock(_component_GoogleLogin, {
    callback: callback,
    "popup-type": "TOKEN"
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})